import {
  expenseItems,
  expenseItemsYokohama,
  expenseItemsOsaka,
  expenseItemsToda,
} from '@/const.js'

// 地域別経費項目取得
const areaName = process.env.VUE_APP_LOCATION
const items =
  areaName === 'YOKOHAMA'
    ? expenseItemsYokohama
    : areaName === 'OSAKA'
    ? expenseItemsOsaka
    : areaName === 'TODA'
    ? expenseItemsToda
    : expenseItems

/**
 * 経費項目タイプに対応する経費項目名を返す
 */
export const expenseTypesToString = type => {
  let typeText = ''
  items.some(element => {
    if (type === element.id) {
      typeText = element.name
      return true
    }
  })
  return typeText
}

/**
 * 経費項目タイプに対応する経費項目タイプと経費項目名を返す
 */
export const expenseTypesToArray = type => {
  let res = []
  items.some(element => {
    if (type === element.id) {
      res.push({ id: element.id, name: element.name })
    }
  })
  return res
}

/**
 * 経費項目の経費項目タイプと経費項目名を返す
 */
export const expenseTypesAdjust = () => {
  let res = []
  items.some(element => {
    res.push({ id: element.id, name: element.name })
  })
  return res
}
